import script from "./create-contragent.vue?vue&type=script&setup=true&lang=js"
export * from "./create-contragent.vue?vue&type=script&setup=true&lang=js"

import "./create-contragent.vue?vue&type=style&index=0&id=23e7b150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e7b150"]])

export default __exports__